var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenprofile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_307_1115",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_307_1115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 15.1667C15.1278 15.1667 16.0903 14.7681 16.8875 13.9708C17.6847 13.1736 18.0833 12.2111 18.0833 11.0833C18.0833 9.95556 17.6847 8.99306 16.8875 8.19583C16.0903 7.39861 15.1278 7 14 7C12.8722 7 11.9097 7.39861 11.1125 8.19583C10.3153 8.99306 9.91667 9.95556 9.91667 11.0833C9.91667 12.2111 10.3153 13.1736 11.1125 13.9708C11.9097 14.7681 12.8722 15.1667 14 15.1667ZM5.83333 24.5C5.19167 24.5 4.64217 24.2717 4.18483 23.8152C3.72828 23.3578 3.5 22.8083 3.5 22.1667V5.83333C3.5 5.19167 3.72828 4.64217 4.18483 4.18483C4.64217 3.72828 5.19167 3.5 5.83333 3.5H22.1667C22.8083 3.5 23.3578 3.72828 23.8152 4.18483C24.2717 4.64217 24.5 5.19167 24.5 5.83333V22.1667C24.5 22.8083 24.2717 23.3578 23.8152 23.8152C23.3578 24.2717 22.8083 24.5 22.1667 24.5H5.83333ZM5.83333 22.1667H22.1667V20.825C21.1167 19.7944 19.8967 18.9824 18.5068 18.389C17.1162 17.7963 15.6139 17.5 14 17.5C12.3861 17.5 10.8842 17.7963 9.49433 18.389C8.10367 18.9824 6.88333 19.7944 5.83333 20.825V22.1667Z",
    fill: "#47C87A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenprofile);
export default __webpack_public_path__ + "static/media/greenprofile.6edb16f47cead55dcea4b52daa8b87c4.svg";
export { ForwardRef as ReactComponent };